"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asError = exports.WrappedNonError = void 0;
class WrappedNonError extends Error {
    constructor(nonError) {
        super(WrappedNonError.getMessage(nonError));
        this.name = 'WrappedNonError';
    }
    static getMessage(nonError) {
        if (typeof (nonError) === 'object') {
            try {
                return JSON.stringify(nonError);
            }
            catch (_a) {
                return '(Failed to JSON.stringify thrown object)';
            }
        }
        return String(nonError);
    }
}
exports.WrappedNonError = WrappedNonError;
const asError = (x) => (x instanceof Error ? x : new WrappedNonError(x));
exports.asError = asError;
//# sourceMappingURL=error.js.map